import { gql } from '@apollo/client';

export const GET_WHITELABEL_LOGO_FOR_LEFT_NAVIGATION_QUERY = gql`
    query GetWhitelabelLogoForLeftNavigation {
        me {
            id
            whitelabelLogo {
                id
                signedUrl
            }
        }
    }
`;
